<template>
  <bootstrap-modal
    v-if="show"
    class="warning-modal"
    @modal-close="$emit('close')"
  >
    <div
      slot="header"
      class="modal-header"
    >
      <button
        type="button"
        class="close modal__close-button"
        data-dismiss="modal"
        aria-label="Close"
        @click="$emit('close')"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4
        id="warningModalLabel"
        class="modal-title"
      >
        <contentful-text :item="contentfulText('remove-confirm-modal-title')" />
      </h4>
    </div>
    <div
      slot="body"
      class="modal-body warning-modal__body"
    >
      <contentful-text
        :apply-markdown="true"
        :item="contentfulText('remove-confirm-modal-body')"
      />
    </div>
    <div
      slot="footer"
      class="modal-footer"
    >
      <div class="row">
        <div class="col-xs-6">
          <button
            type="button"
            class="button button--fw button--centered"
            @click="$emit('close')"
          >
            <contentful-text :item="contentfulText('cancel-label')" />
          </button>
        </div>
        <div class="col-xs-6">
          <button
            type="button"
            class="button button--fw button--centered"
            @click="$emit('confirm')"
          >
            <contentful-text :item="contentfulText('confirm-label')" />
          </button>
        </div>
      </div>
    </div>
  </bootstrap-modal>
</template>

<script>
import BootstrapModal from '@Shared/components/BootstrapModal.vue'
import ContentfulMixin from '@Shared/mixins/contentful'

export default {
  name: 'RemoveSelectionConfirmModal',
  components: {
    BootstrapModal
  },
  mixins: [
    ContentfulMixin
  ],
  props: {
    show: { type: Boolean, default: false, required: true }
  },
  data () {
    return {
      showModal: false
    }
  },
  computed: {
    content () {
      return this.$store.state.mixMatchPhotoSelectionModuleContent
    }
  },
  watch: {
    show (v, ov) {
      this.showModal = v
    }
  },
  mounted () {
    this.showModal = this.show
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// WebResources/vue/default/catalog-mix/components/PhotoSelection/Slot/RemoveSelectionConfirmModal.vue